import {
    awsPresignedUpload,
    getUploadContentType,
} from '@/components/shared/api/awsPresignedUpload';
import {
    getApplicantPresignedUrl,
    OriginationFile,
} from '@/components/shared/api/endpoints/applicant';
import { useConfirmApplicantDocMutation } from '@/components/shared/api/mutations/applicant';
import { getOktaAuthEmail } from '@/components/shared/utils/sessionStorageUtils';

import { FileType } from '../../Applicant.types';

export const useApplicantPresignedUpload = () => {
    const { mutateAsync: confirmApplicantDoc } = useConfirmApplicantDocMutation();

    const uploadApplicantDocAws = async (
        applicantId: string,
        file: File,
        fileType?: FileType,
    ): Promise<OriginationFile | undefined> => {
        const fileEncoded = new File([file], encodeURI(file.name), {
            type: getUploadContentType(file),
        });

        const applicantUrlResponse = await getApplicantPresignedUrl({
            applicantId,
            fileName: fileEncoded.name,
            contentType: fileEncoded.type,
        });

        const awsResponse = await awsPresignedUpload(file, applicantUrlResponse?.url || '');
        const presignedUploadUrl = awsResponse?.config.url;

        if (presignedUploadUrl) {
            const oktaAuthEmail = getOktaAuthEmail();

            const confirmDoc = await confirmApplicantDoc({
                applicantId,
                body: {
                    presignedUploadUrl,
                    path: applicantUrlResponse?.path || '',
                    fileName: file.name,
                    fileType,
                    uploadedBy: oktaAuthEmail,
                },
            });

            return confirmDoc;
        }
    };

    return { uploadApplicantDocAws };
};
